import { Button, Image } from '@chakra-ui/react';
import React from 'react';
import useModelButtonTelemedicina from './useModelButtonTelemedicina';
import IconTelemed from '../../../images/assets/icons/icontelemed.svg';
import ModalTelemedicinaHome from '../Main/Telemedicina/ModalTelemedicinaHome/ModalTelemedicinaHome';
function ButtonTelemedicina() {
  const { modalTelemedicinaHome, theme, hiddenButton, cacheAgendamento, validaFilaAtendimento } = useModelButtonTelemedicina();
  
  return (
    <>
      <ModalTelemedicinaHome disclosure={modalTelemedicinaHome} cacheAgendamento={cacheAgendamento} refetchAtendimento={validaFilaAtendimento}/>
      <Button
        hidden={hiddenButton}
        className="pulse"
        position="fixed"
        bottom="80px"
        right="24px"
        zIndex="999"
        borderRadius="full"
        boxSize="80px"
        boxShadow="lg"
        onClick={() => modalTelemedicinaHome.onOpen()}
        display="flex"
        alignItems="center"
        justifyContent="center"
        p={0}
        bg={'red.500'}
      >
        <Image src={IconTelemed} />
      </Button>
    </>
  );
}

export default ButtonTelemedicina;
